import React, { Component } from 'react'
import axios from 'axios'
import { injectIntl, FormattedMessage } from 'react-intl';

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Label,
    Legend,
    ResponsiveContainer
  } from "recharts";
  
import LoadingControl from './Loading';
import {ApplyFilterParams} from '../utils/ApplyFilterParams'

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="custom-tooltip-line">{`${label} : ${payload[0].value}`}</p>
        </div>
      );
    }
}

class ChartDistribution extends Component {

    constructor (props) {
        super(props);

        this.state = {
            error: null,
            isLoaded: false,
            data: null,
            dataKey: "pages"
          };

        this.current_chart_type = 1;
        this.max_chart_type = 4;
        this.charts_url = [
            { url : "/charts_hours?noStats=false&" + this.props.object_id, label : "Hour"},
            { url : "/charts_weekdays?noStats=false&" + this.props.object_id, label : "DayOfWeek"},
            { url : "/charts_monthdays?noStats=false&" + this.props.object_id, label : "DayOfMonth"},
            { url : "/charts_months?noStats=false&" + this.props.object_id, label : "Month"},
            { url : "/charts_years?noStats=false&" + this.props.object_id, label : "Year"}
        ];

        this.label = this.props.intl.formatMessage({id: this.charts_url[this.current_chart_type].label});

        this.current_data_type = 0;
        this.max_data_type = 2;
        this.charts_data_key = [
            {key : "pages", legend : "Pages"},
            {key : "documents", legend : "Documents"},
            {key : "cost", legend : "Cost"},
        ];

        this.getLegend = this.getLegend.bind(this);
    }

    onYAxisClick(e) {
        this.current_data_type++;
        if (this.current_data_type > this.max_data_type) {
            this.current_data_type = 0;            
        }

        this.setState({dataKey : this.charts_data_key[this.current_data_type].key});
    }

    onXAxisClick(e) {
        this.current_chart_type++;
        if (this.current_chart_type > this.max_chart_type) {
            this.current_chart_type = 0;
        }
        
        this.label = this.props.intl.formatMessage({id: this.charts_url[this.current_chart_type].label});

        this.update();
    }

    getLegend(props)
    {       
        return <div className='chart-legend'><FormattedMessage id={this.charts_data_key[this.current_data_type].legend}/></div>
    }

    async getData() {      
        const url = ApplyFilterParams(this.charts_url[this.current_chart_type].url, this.props.filterData);
        const res = await axios(url);
        return res.data;
        }

    update() {
        this.setState({isLoaded: false});
    
        this.getData()
        .then(res => {
            this.setState({ error: null, isLoaded: true, data: res });
        })
        .catch(err => {
            console.log(err);
            this.setState( {error: err, isLoaded: false, data: null });
        });
        }  
        
    componentDidMount() {
            this.update();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filterData !== this.props.filterData) {
            this.update();
        }
    }

    render(){

        if(this.state.error != null)
        {
            return (
                <div>
                    <h3>{this.state.error.message}</h3>
                </div>
            );
        }
        else if (!this.state.isLoaded)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {
            return (
            <ResponsiveContainer width = {400} height="99%">
                <BarChart
                    data={this.state.data}                    
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5
                    }}
                    >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" cursor="pointer" onClick = {(e) => {this.onXAxisClick(e)}}>
                        <Label value={this.label} offset={0} position="insideBottom" />
                    </XAxis>
                    <YAxis cursor="pointer" onClick = {(e) => {this.onYAxisClick(e)}}/>
                    <Legend verticalAlign="top" height={36} content={this.getLegend}/>
                    <Tooltip content={<CustomTooltip/>}/>
                    <Bar dataKey={this.state.dataKey} fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        )
    }
  }
}   

export default (injectIntl(ChartDistribution, {
    withRef: true,
    }));